const o = [
  {
    name: '运营看板',
    enname: 'Dashboard',
    src: require('@/assets/icon_navleft_01.png'),
    value: '/admin/index',
  },
  {
    name: '车辆定位',
    enname: 'Position',
    src: require('@/assets/icon_navleft_13.png'),
    value: '/admin/carposition',
  },
  // {
  //   name: '财务分析',
  //   src: require('@/assets/icon_navleft_11.png'),
  //   value: '/admin/financialAnalysis',
  // },
  {
    name: '运营分析',
    enname: 'Operational Analysis',
    src: require('@/assets/icon_navleft_12.png'),
    value: '/admin/dataCenter',
  },
  {
    name: '报单管理',
    enname: 'Report Order',
    src: require('@/assets/icon_navleft_16.png'),
    value: '/reportOrder',
    children: [
      {
        name: '报单列表',
        value: '/reportOrder/list',
      },
    ]
  },
  {
    name: '运单管理',
    enname: 'Order',
    src: require('@/assets/icon_navleft_02.png'),
    value: '/order',
    children: [
      {
        name: '普通运单',
        enname: 'Dashboard',
        value: '/order/nocontract',
      },
      {
        name: '合同运单',
        //src: require('@/assets/icon_navleft_01.png'),
        value: '/order/contract',
      },
      {
        name: '运单补差',
        value: '/order/makeup',
      },
      {
        name: '运单回收站',
        value: '/order/recycle',
      },
    ],
  },
  {
    name: '合同管理',
    enname: 'Contract',
    src: require('@/assets/icon_navleft_03.png'),
    value: '/contract',
    children: [
      {
        name: '合同列表',
        value: '/contract/list',
      },
      {
        name: '合同补差',
        value: '/contract/makeup',
      },
    ],
  },
  {
    name: '客户管理',
    enname: 'Customer',
    src: require('@/assets/icon_navleft_04.png'),
    value: '/customer',
    children: [
      {
        name: '客户列表',
        value: '/customer/manage',
        // value: '/customer/list',
      },
      // {
      //   name: '报单管理',
      //   value: '/customer/reportOrder',
      // },
      {
        name: '操作日志',
        value: '/customer/log',
      },
    ],
  },
  {
    name: '车辆管理',
    enname: 'Vehicle',
    src: require('@/assets/icon_navleft_05.png'),
    value: '/vehicle',
    children: [
      {
        name: '自有车辆',
        value: '/vehicle/manage',
      },
      {
        name: '挂车管理',
        value: '/vehicle/hang',
      },
      {
        name: '车队分组',
        value: '/vehicle/group',
      },
      {
        name: '违章管理',
        value: '/vehicle/breakRules',
      },
      {
        name: '车辆年检',
        value: '/vehicle/inspect',
      },
      {
        name: '临期查询',
        value: '/vehicle/documents',
      },
    ],
  },
  {
    name: '承运管理',
    enname: 'carrier',
    src: require('@/assets/icon_navleft_17.png'),
    value: '/carrier',
    children: [
      {
        name: '承运商管理',
        value: '/carrier/manage',
      },
      {
        name: '外协车辆',
        value: '/carrier/hirecar',
      },
    ],
  },
  {
    name: '维保管理',
    enname: 'Repair',
    src: require('@/assets/icon_navleft_06.png'),
    value: '/fix',
    children: [
      {
        name: '维保列表',
        value: '/fix/list',
      },
      {
        name: '维修商管理',
        value: '/fix/repairer',
      },
    ],
  },
  {
    name: '人员管理',
    enname: 'Staff',
    src: require('@/assets/icon_navleft_07.png'),
    value: '/staff',
    children: [
      // {
      //   name: '车队经理管理',
      //   value: '/staff/manager',
      // },
      {
        name: '车队长管理',
        value: '/staff/captain',
      },
      {
        name: '会计管理',
        value: '/staff/mainAccountant',
      },
      /*{
        name: '分管会计管理',
        value: '/staff/specialAccountant',
      },
      {
        name: '出纳管理',
        value: '/staff/cashier',
      },*/

      // {
      //   name: '副队长管理',
      //   value: '/staff/viceCaptain',
      // },
      {
        name: '机务管理',
        value: '/staff/maintenance',
      },
      {
        name: '车务管理',
        value: '/staff/vehicleService',
      },
      {
        name: '司机管理',
        value: '/staff/driver',
      },
      {
        name: '押运员管理',
        value: '/staff/escort',
      },
      {
        name: '打短司机管理',
        value: '/staff/tempDriver',
      },
      {
        name: '打短押运管理',
        value: '/staff/tempEscort',
      },
    ],
  },
  {
    name: '考勤管理',
    enname: 'Attendance',
    src: require('@/assets/icon_navleft_14.png'),
    value: '/attendance',
    children: [
      {
        name: '车辆考勤',
        value: '/attendance/vehicle',
      },
      {
        name: '考勤汇总',
        value: '/attendance/summary',
      },
      {
        name: '司机出勤',
        value: '/attendance/driver',
      },
      {
        name: '押运出勤',
        value: '/attendance/escort',
      },
    ],
  },
  {
    name: '财务管理',
    enname: 'Finance',
    src: require('@/assets/icon_navleft_08.png'),
    value: '/finance',
    children: [
      {
        name: '预警管理',
        value: '/finance/financeFleetAbnormal',
      },
      {
        name: '运费统计表',
        value: '/finance/feightStatistics',
      },
      {
        name: '预支款管理',
        value: '/finance/initialPayment',
      },
      {
        name: '应收账款管理',
        value: '/finance/shipper',
      },
      {
        name: '应付账款管理',
        value: '/finance/carrier',
      },
      {
        name: '合同账款管理',
        value: '/finance/accounts',
      },
      // {
      //   name: '稳定基金管理',
      //   value: '/finance/stabilizationFund',
      // },
      {
        name: '固定费用支出表',
        value: '/finance/fixedFeeList',
      },
      {
        name: '出车费用汇总表',
        value: '/finance/expenseSummary',
      },
      {
        name: '油气费汇总表',
        value: '/finance/oilFee',
      },
      {
        name: '承运利润表',
        value: '/finance/carrierProfit',
      },
      {
        name: '车队利润表',
        value: '/finance/estimatedProfit',
      },
      {
        name: '车队运营统计表',
        value: '/finance/financeFleetSummary',
      },
      // {
      //   name: '押运员预计工资',
      //   value: '/finance/escortSalary',
      // },
      {
        name: '车队长工资表',
        value: '/finance/captainSalary',
      },
      {
        name: '月度统计表',
        value: '/finance/monthlyStatistical',
      },
      {
        name: '月度分析表',
        value: '/finance/monthlyAnalysis',
      },

    ],
  },
  {
    name: '系统设置',
    enname: 'System',
    src: require('@/assets/icon_navleft_09.png'),
    value: '/system',
    children: [
      {
        name: '提醒人配置',
        value: '/system/reminderConfig',
      },
      {
        name: '预警阈值设置',
        value: '/system/warningConfig',
      },
      {
        name: '工资提成设置',
        value: '/system/baseSalary',
      },
      {
        name: '固定费用配置',
        value: '/system/fixedFee',
      },
      {
        name: '出车费用配置',
        value: '/system/drivingFee',
      },
      {
        name: '附加费用配置',
        value: '/system/extraFee',
      },
      {
        name: '油气站配置',
        value: '/system/stationConfig',
      },
      {
        name: '货物配置',
        value: '/system/cargoConfig',
      },
      {
        name: '车辆类型配置',
        value: '/system/vehicleTypeConfig',
      },
      {
        name: '车辆证件配置',
        value: '/system/documentConfig',
      },
      {
        name: '车辆保险配置',
        value: '/system/insuranceConfig',
      },
      {
        name: '维保类型配置',
        value: '/system/repair',
      },
      {
        name: '基础设置',
        value: '/system/others',
      },
      {
        name: '登录日志',
        value: '/system/loginLog',
      },
    ],
  },
  {
    name: '帮助中心',
    enname: 'Help',
    src: require('@/assets/icon_navleft_15.png'),
    value: '/help',
    children: [
      // {
      //   name: '操作手册',
      //   value: '/help/operation',
      // },
      {
        name: '更新日志',
        value: '/help/log',
      },
      {
        name: '改进建议',
        value: '/help/improve',
      },
    ],
  },
]

export default o